// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description__wrapper {
  display: grid;
  gap: 24px;
  padding: 12px 20px;
}
.description__item {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
}
.description__item-link {
  color: #000000;
}
.description__item-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #7F8681;
}

.brief-description__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #326AAB;
}
.file__item {
  padding: 8px 0;
  gap: 8px;
  border-radius: 6px;
  border-bottom: 1px solid #E3E9E5;
  background: #fff;
  width: 100%;
  cursor: pointer;
}
.file__item-type {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid rgba(31, 154, 72, 0.2);
  background: #DEF9E6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1F9A48;
  font-size: 13px;
  font-weight: 600;
  line-height: 17.7px;
  text-align: left;
  text-transform: uppercase;
}
.file__item-name {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}
.file__item-info__description {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.15px;
  text-align: left;
  color: #7E8681;
}

.criteria {
  display: flex;
  flex-flow: column;
  gap: 12px;
}
.criteria__card {
  width: 100%;
  padding: 12px 16px 16px 16px;
  gap: 16px;
  border-radius: 6px;
  background: #F7F7F7;
  display: flex;
  flex-flow: column;
}
.criteria__card-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
}

.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
  padding-inline-start: 10px;
  padding-inline-end: unset;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
  margin-inline-end: unset;
  flex: unset;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 0;
  align-items: center;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #7F8681;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  fill: #7F8681;
}

.ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
}

.status-bar__number {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 2px solid #7E8681;
}
.status-bar__number.disabled {
  border-color: #D5DCDF;
}
.status-bar__text {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #7E8681;
  white-space: nowrap;
}
.status-bar__text.disabled {
  color: #D5DCDF;
}
.status-bar__item.active .status-bar__text {
  color: #000000;
}
.status-bar__item.active .status-bar__number {
  border-color: #000000;
}
.status-bar__link {
  display: flex;
  gap: 8px;
  align-items: center;
}

.stages__items {
  overflow-y: auto;
  gap: 2px;
}
.stages__items .ant-picker-outlined {
  height: 24px;
  padding: 2px 7px 2px 7px;
}
.stages__items .ant-picker-input {
  flex-direction: row-reverse;
  align-items: center;
}
.stages__items .ant-picker-input input {
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: #384146;
}
.stages__items .ant-picker-input .ant-picker-suffix {
  margin-inline-start: unset;
  padding-bottom: 1px;
}
.stages__items .ant-picker-input .ant-picker-clear {
  left: 0;
  width: 10px;
}
.stages__items .ant-picker-input .ant-picker-clear svg {
  width: 10px;
}
.stages__item {
  width: 100%;
  border-radius: 6px;
  padding: 5px;
  background: #FAFAFA;
  border: 1px solid #FAFAFA;
  cursor: pointer;
}
.stages__item.completed {
  background: #F6FCF8;
  border: 1px solid #f6fcf8;
}
.stages__item.completed:not(.advance) .stages__fact-date .ant-picker-outlined {
  background: #DBF4E3;
}
.stages__item.in-work {
  background: #FFFCEB;
  border: 1px solid #FFFCEB;
}
.stages__item.in-work .stages__fact-date .ant-picker-outlined {
  background: #F3F6F8;
}
.stages__item.in-work .stages__item-duration {
  background: #F3F6F8;
}
.stages__item.expired {
  background: #FFEEEB;
  border: 1px solid #FFEEEB;
}
.stages__item.overdue:not(.not-started) .stages__item-text .ant-typography, .stages__item.overdue:not(.not-started) .stages__date-diff {
  color: #C11801;
}
.stages__item.overdue:not(.not-started) .stages__fact-date .ant-picker-outlined {
  background: #FFEEEB;
}
.stages__item.overdue:not(.not-started) .stages__item-duration {
  background: #FFEEEB;
}
.stages__item.advance:not(.not-started) .stages__item-text .ant-typography, .stages__item.advance:not(.not-started) .stages__date-diff {
  color: #1066CB;
}
.stages__item.stages__item_filtered {
  border: 1px solid #85929A;
}
.stages__item-duration {
  padding: 2px 8px 4px 8px;
  gap: 6px;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: #384146;
}
.stages__item-manager {
  padding: 2px 8px 4px 8px;
  gap: 6px;
  border-radius: 4px;
  background: #F3F6F8;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: #384146;
  cursor: pointer;
}
.stages__item-manager_current {
  background: #384146;
  color: #fff;
}
.stages__item-manager_expired {
  background: #FFBFB7;
  color: #384146;
}
.stages__item-content {
  width: 100%;
}
.stages__item-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.stages {
  /*&__item-date-text {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
      color: #7E8681;
  }*/
}

.ant-form-item {
  margin: 0;
}

.criterion__delete {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: #C11801;
  cursor: pointer;
}
.criterion__status-item {
  padding: 4px 8px 8px 8px;
  gap: 4px;
  border-radius: 6px;
  background: #F1F5F7;
}
.criterion__status-item__label {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}
.criterion__status-item__text {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
.criterion__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #092A3A;
}
.criterion__stages-button {
  width: 440px;
  height: 58px;
  padding: 16px;
  gap: 6px;
  border-radius: 6px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1019607843);
  position: fixed;
  right: 16px;
  bottom: 16px;
  cursor: pointer;
  background: #fff;
  z-index: 11;
}
.criterion__stages-button__text {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  letter-spacing: 0.3px;
}
.criterion__stages-button__expand {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  text-align: right;
  color: #417EC6;
}
.criterion__stages-block {
  display: flex;
  flex-flow: column;
  width: 636px;
  padding: 16px;
  gap: 6px;
  border-radius: 6px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1019607843);
  position: fixed;
  right: 16px;
  top: 64px;
  cursor: pointer;
  background: #fff;
  overflow-y: auto;
  max-height: 80vh;
  z-index: 11;
}
.criterion__message {
  top: 526px;
  left: 80px;
  padding: 16px 24px 24px 24px;
  gap: 24px;
  border-radius: 6px;
  background: #19BB4F;
}
.criterion__message-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  text-align: center;
  color: #fff;
}
.criterion__message-button {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 8px 10px 8px;
  gap: 4px;
  border-radius: 6px;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  color: #384146;
  cursor: pointer;
}

.criterion-stages-enter {
  height: 50px;
  transform: translateY(850px);
}

.criterion-stages-enter-active {
  height: auto;
  transform: translateY(0);
  transition: transform 400ms, height 400ms;
}

.criterion-stages-exit {
  height: 600px;
  transform: translateY(0);
}

.criterion-stages-exit-active {
  height: 50px;
  transform: translateY(850px);
  transition: transform 400ms, height 300ms;
}

.criterion-stages-button-enter {
  transform: translateY(-850px);
}

.criterion-stages-button-enter-active {
  transform: translateY(0);
  transition: transform 400ms;
}

.criterion-stages-button-exit {
  transform: translateY(0);
}

.criterion-stages-button-exit-active {
  transform: translateY(-850px);
  transition: transform 400ms;
}

.commentary__wrapper {
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
}
.commentary__block {
  display: flex;
  padding: 32px 20px;
  border-top: 1px solid #E3E9E5;
  position: relative;
}
.commentary__list {
  overflow-y: auto;
  padding: 12px 0;
}
.commentary__date {
  border: 1px solid #E3E9E5;
  border-radius: 6px;
  position: absolute;
  top: -13px;
  left: 40%;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 600;
  background: #fff;
}
.commentary__items {
  width: 100%;
}
.commentary__item {
  width: 100%;
  gap: 8px;
  margin-top: 16px;
  position: relative;
}
.commentary__item--author {
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.15px;
  text-align: left;
}
.commentary__item--position {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #7E8681;
}
.commentary__item--time {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  letter-spacing: 0.15px;
  text-align: left;
  color: #7E8681;
  white-space: nowrap;
}
.commentary__item--text {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.15px;
  text-align: left;
  white-space: break-spaces;
}
.commentary__item--children {
  padding: 4px 4px 4px 10px;
  border-radius: 6px;
  border: 1px solid #ECECEC;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.commentary__item--children-items {
  padding: 0 0 0 16px;
  width: 100%;
}
.commentary__item--reply-button {
  cursor: pointer;
}
.commentary__item:hover > .commentary__item--reply-button {
  display: flex;
}
.commentary__field-wrapper {
  border-top: 1px solid #E6EDF1;
}
.commentary__field {
  padding: 8px 15px;
}
.commentary__field--button {
  cursor: pointer;
}
.commentary__field--author {
  font-weight: 600;
}
.commentary__reply {
  padding: 10px;
}
.commentary__reply--close-button {
  cursor: pointer;
}

.planner__block-title {
  color: #092A3A;
}
.planner__bordered {
  border: 1px solid #CED9E0;
  box-sizing: border-box;
}
.planner__bottom-bordered {
  border-bottom: 1px solid #CED9E0;
}
.planner__right-bordered {
  border-right: 1px solid #CED9E0;
}
.planner__grey {
  background: #F8F8F8;
}
.planner__settings-button {
  height: 34px;
  display: flex;
  align-content: center;
  border-radius: 6px;
  padding-top: 4px;
  padding-right: 10px;
  padding-bottom: 6px;
  padding-left: 10px;
  gap: 8px;
  background: #F3F6F8;
  cursor: pointer;
  white-space: nowrap;
}
.planner__header-title {
  color: #1066CB;
  height: 40px;
}

.summary {
  padding: 8px 12px 12px 12px;
  gap: 14px;
  border-radius: 8px;
  border: 1px solid #E3E9E5;
  background: #F8F8F8;
}
.summary__items {
  background: #FFFFFF;
  border: 1px solid #E3E9E5;
  padding: 8px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.summary__items--accepted {
  border: 1px solid #1066CB;
}
.summary__items-item {
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  justify-content: space-between;
}
.summary__items-item__label {
  color: #7E8681;
}
.summary__items-item__valuel {
  color: #000000;
}
.summary__block-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #092A3A;
}
.summary__block-title__description {
  color: #7E8681;
}
.summary__block-title__description-quarter {
  color: #092A3A;
}

.files {
  border-top: 1px solid #E3E9E5;
  padding-top: 8px;
}

.optimization {
  border-top: 1px solid #E3E9E5;
  padding-top: 16px;
}
.optimization .ant-form-item-label label {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #092A3A;
}
.optimization__field-description {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #7E8681;
}
.optimization__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  letter-spacing: 0.15px;
  text-align: left;
  color: #7E8681;
}
.optimization__table {
  width: 100%;
  font-size: 12px;
}
.optimization__table-header {
  padding: 12px 8px;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: left;
  margin-bottom: -1px;
}
.optimization__table-bordered {
  border: 1px solid #CED9E0;
  box-sizing: border-box;
}
.optimization__table-border-right {
  border-right: 1px solid #CED9E0;
}
.optimization__table-border-bottom {
  border-bottom: 1px solid #CED9E0;
}
.optimization__table-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
}
.optimization__table-field .ant-form-item-control-input-content {
  display: flex;
  justify-content: flex-end;
}
.optimization__table-grey {
  background: #F8F8F8;
  color: #7E8681;
}
.optimization__table-field-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding: 4px 8px;
}
.optimization__table-inventory {
  height: 100%;
  align-items: flex-start;
  justify-content: flex-end;
}
.optimization__table input.ant-input-number-input {
  text-align: right;
}
.optimization__npvs {
  color: #1066CB;
  cursor: pointer;
}
.optimization__npvs-close {
  cursor: pointer;
}
.optimization .channels-block__title {
  font-weight: 600;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
}
.optimization .collapse-item__title {
  font-weight: 600;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0.15px;
  color: #1066CB;
}
.optimization .collapse-item__date {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.15px;
  color: #85929A;
}
.optimization .collapse-item__input {
  font-size: 12px;
}
.optimization .ant-collapse-item.ant-collapse-item-active .collapse-item__title {
  color: #000;
}

.variant__header {
  padding: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  text-align: left;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.variant__columns {
  width: 100px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.variant__row {
  width: 100px;
  display: grid;
  margin-top: -1px;
}
.variant__column {
  min-width: 20%;
}
.variant__field {
  padding: 4px 8px;
}
.variant__field:last-child {
  border-right: none;
}
.variant__field-title {
  color: #7E8681;
}
.variant__total {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  font-weight: 600;
}

.ant-layout .variant-table.ant-table-wrapper .ant-table-thead > tr > th {
  font-size: 14px;
  color: #7E8681;
  font-weight: 600;
  background: #fff;
}
.ant-layout .variant-table.ant-table-wrapper .ant-table-tbody > tr > td {
  padding: 2px 8px;
}
.ant-layout .variant-table.ant-table-wrapper .ant-table-tbody > tr:last-child > td:first-child {
  border-bottom-left-radius: 8px;
}
.ant-layout .variant-table.ant-table-wrapper .ant-table-tbody > tr:last-child > td:last-child {
  border-bottom-right-radius: 8px;
}
.ant-layout .variant-table.with-total .ant-table-tbody > tr:last-child > td {
  font-weight: 600;
  background: #fafafa;
}
.ant-layout .variant-table__title {
  color: #000;
}
.ant-layout .variant-table__delete-button {
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: #C11801;
}
.ant-layout .variant-table__accepted.ant-table-wrapper .ant-table-bordered {
  border: 1px solid #1066CB;
  border-radius: 8px;
}
.ant-layout .variant-table__accepted.ant-table-wrapper .ant-table-container {
  border-end-start-radius: 8px;
  border-end-end-radius: 8px;
}

.data-factors-collapse.ant-collapse {
  border-radius: unset;
}
.data-factors-collapse.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  justify-content: space-between;
  padding: 8px;
  border-radius: unset;
}

.compare__plan-popover-item_colored {
  color: #1066CB;
}
.compare__plan-popover-item {
  font-weight: 600;
  cursor: pointer;
}
.compare__fixed-cell.ant-table-cell {
  background: #FFFCEE !important;
}

.compare-filter__title {
  color: #092A3A;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
}
.compare-filter__items-title {
  border-bottom: 1px solid #E3E9E5;
  padding: 0 8px 10px 8px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
.compare-filter__items-title-count {
  color: #7E8681;
}
.compare-filter__block {
  padding: 12px 0;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid #E3E9E5;
}
.compare-filter__item {
  padding: 2px 12px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}

.data-total__group-title {
  color: #1A76E2;
  cursor: pointer;
}
.data-total__group-title.expanded {
  color: #7E8681;
}

.total-row {
  font-weight: 700;
}

.ant-card .ant-card-body.data-total__card-body {
  padding: 0;
}

.highlight {
  animation: pulse 1s ease-in-out 2;
}

.compare__items .ant-table-row[data-row-key=total],
.compare__items .ant-table-row[data-row-key=total_media],
.compare__items .ant-table-row[data-row-key=total_non_media] {
  font-weight: 600;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(24, 143, 207, 0.7);
  }
  25%, 75% {
    box-shadow: 0 0 0 4px rgba(24, 143, 207, 0.4);
  }
  50% {
    box-shadow: 0 0 0 2px rgba(24, 143, 207, 0);
  }
}
.factor-channels {
  border-radius: 6px;
  margin-bottom: -1px;
}
.factor-channels__bordered {
  border: 1px solid #CED9E0;
  box-sizing: border-box;
}
.factor-channels__bottom-bordered {
  border-bottom: 1px solid #CED9E0;
}
.factor-channels__top-bordered {
  border-top: 1px solid #CED9E0;
}
.factor-channels__right-bordered {
  border-right: 1px solid #CED9E0;
}
.factor-channels__grey {
  background: #F8F8F8;
}
.factor-channels__field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px;
}
.factor-channels__name {
  word-break: break-word;
}
.factor-channels__upload-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: #000000;
}
.factor-channels__upload-button {
  border-radius: 6px;
  padding: 10px 16px;
  gap: 8px;
  background-color: #F3F6F8;
  cursor: pointer;
  font-size: 14px;
  color: #384146;
}
.factor-channels .ant-radio-wrapper .ant-radio-inner {
  border-color: unset;
}
.factor-channels .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
  background-color: #000;
}
.factor-channels .ant-radio-wrapper .ant-radio-checked .ant-radio-inner:after {
  content: unset;
}
.factor-channels__download {
  border-radius: 6px;
  padding: 6px 10px;
  gap: 4px;
  border: 1px solid #E9EEF0;
  background: #FAFAFA;
}

.highlight-row {
  background-color: #f0f0f0 !important;
  transition: background-color 1.5s ease;
}

.report__wrapper {
  padding: 16px 20px;
  height: 100%;
}
.report__wrapper .ant-segmented-group {
  justify-content: space-between;
}
.report__wrapper .ant-segmented-group .ant-segmented-item {
  padding: 0 10px;
}
.report__wrapper .ant-segmented-group .ant-segmented-item-selected, .report__wrapper .ant-segmented-group .ant-segmented-thumb-motion {
  background: #000;
  color: #fff;
}
.report__quarters .ant-segmented-group .ant-segmented-item {
  padding: 0 16px;
}
.report__empty-text {
  color: #7E8681;
}
.report__link {
  width: 100%;
  height: 40px;
  padding: 7px 15px;
  border-radius: 6px;
  background: #1066CB;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
.report__link:hover {
  color: #fff;
  opacity: 0.9;
}

.report-forecasts__title {
  font-weight: 600;
  font-size: 14px;
}
.report-forecasts__empty {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding-top: 10px;
  padding-right: 8px;
  padding-bottom: 10px;
  padding-left: 8px;
  background: #FFFCEB;
  width: 100%;
  color: #181A1C;
}
.report-forecasts__link {
  width: 100%;
  border-radius: 6px;
  border-width: 1.5px;
  opacity: 1;
  gap: 8px;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 10px;
  border: 1.5px solid #1A76E2;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 20px;
  color: #1066CB;
}

.admin-panel > div {
  width: 100%;
}

.workgroup__empty {
  padding: 10px 8px;
  border-radius: 4px;
  background: #EFF5FF;
  font-size: 11px;
  font-weight: 400;
  line-height: 14.98px;
}
.workgroup__item {
  padding: 6px;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #E9EEF0;
  display: flex;
  justify-content: space-between;
}
.workgroup__item-user {
  display: grid;
  font-size: 12px;
  grid-template-columns: 1fr 2fr;
  width: 100%;
}
.workgroup__item-name {
  font-weight: 600;
}
.workgroup__item-email {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  letter-spacing: 0.15px;
  text-align: left;
  color: #85929A;
}
.workgroup__item-action {
  font-size: 12px;
  cursor: pointer;
}
.workgroup__channels {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  letter-spacing: 0.15px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.workgroup__channels-title {
  font-weight: 600;
}
.workgroup__channels-content {
  width: 100%;
}

@font-face {
  font-family: "Open Sans";
  font-display: auto;
  src: local("Arvo"), url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap) format("woff2");
}
body {
  font-family: "Open Sans", sans-serif !important;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "wdth" 100;
  margin: 0;
}

.ant-layout {
  font-family: "Open Sans", sans-serif !important;
}
.ant-layout .ant-layout-sider {
  box-shadow: 1px 0 6px 0 rgba(0, 0, 0, 0.1019607843);
}
.ant-layout .ant-layout-header {
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1019607843);
  z-index: 100;
  justify-content: center;
  height: 48px;
  padding: 0 16px;
}
.ant-layout .ant-table-wrapper .ant-table-thead > tr > th {
  font-size: 12px;
  font-weight: 400;
  color: #7E8681;
  font-family: "Open Sans", sans-serif;
}
.ant-layout .ant-table-cell, .ant-layout .ant-typography {
  font-family: "Open Sans", sans-serif;
}
.ant-layout .ant-card.card-middle .ant-card-body {
  padding: 12px 24px;
}
.ant-layout .ant-typography {
  margin: 0;
}
.ant-layout .ant-upload.ant-upload-select {
  width: 100%;
}
.ant-layout .ant-form-item-has-error textarea {
  border: 1px solid #ff4d4f;
}
.ant-layout .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #7E8681;
  border-color: #7E8681;
}
.ant-layout .ant-checkbox-checked .ant-checkbox-inner:hover {
  background-color: #7E8681;
  border-color: #7E8681;
}
.ant-layout .ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
  background-color: #7E8681 !important;
  opacity: 0.8;
  border-color: #7E8681;
}
.ant-layout .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
  /*background-color: #fff !important;*/
  border-color: #7E8681;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm {
  border-radius: 16px;
  display: block;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm .ant-segmented-item {
  border-radius: 16px;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 14px;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm .ant-segmented-thumb {
  border-radius: 16px;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm.criterion-null {
  background: rgb(239, 239, 239);
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm.criterion-true {
  background: #19bb4f;
}
.ant-layout .ant-segmented.segmented.ant-segmented-sm.criterion-false {
  background: rgba(0, 0, 0, 0.25);
}
.ant-layout .ant-tabs-content, .ant-layout .ant-tabs-tabpane {
  height: 100%;
}
.ant-layout .ant-tabs-nav {
  padding: 0 20px;
}

.ant-popover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #7E8681;
  border-color: #7E8681;
}
.ant-popover .ant-checkbox-checked .ant-checkbox-inner:hover {
  background-color: #7E8681;
  border-color: #7E8681;
}
.ant-popover .ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
  background-color: #7E8681 !important;
  opacity: 0.8;
  border-color: #7E8681;
}
.ant-popover .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
  /*background-color: #fff !important;*/
  border-color: #7E8681;
}

.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background: #fff;
  border-top: 2px solid #96BAE4;
  border-bottom: 2px solid #96BAE4;
}
.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected .ant-table-cell-row-hover {
  background: #fff;
}
.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell:nth-child(2) {
  border-left: 2px solid #96BAE4;
}
.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell:last-child {
  border-right: 2px solid #96BAE4;
}

.ant-table-content {
  /* Define the scrollbar style */
}
.ant-table-content::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.ant-table-content {
  /* Define the thumb style */
}
.ant-table-content::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);
  border-radius: 5px;
}
.ant-table-content {
  /* Define the track style */
}
.ant-table-content::-webkit-scrollbar-track {
  background-color: #ddd;
  border: 1px solid #ccc;
}
.ant-table-content {
  /* Define the button style */
}
.ant-table-content::-webkit-scrollbar-button {
  background-color: #4d7fff;
  border-radius: 5px;
}
.ant-table-content {
  /* Define the button style when being hovered over */
}
.ant-table-content::-webkit-scrollbar-button:hover {
  background-color: #999999;
}
.ant-table-content .ant-table-row.selected {
  background: #e6e6e6;
}

.ant-tabs-nav-wrap .ant-tabs-tab-btn {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: left;
}
.ant-tabs-nav-wrap .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #000000;
}
.ant-tabs-nav-wrap .ant-tabs-tab-icon {
  display: flex;
}
.ant-tabs-nav-wrap .ant-tabs-ink-bar {
  background: #000000;
}

.ant-table-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) #fff;
}

.ant-table-cell .ant-form-item .ant-form-item-control-input {
  min-height: 20px;
}

.page-wrapper {
  display: flex;
  width: 100%;
}
.page-wrapper .main-section {
  padding: 24px 32px;
  flex: 1 1;
  overflow-y: hidden;
}
.page-wrapper .main-section .list-tabs {
  height: 28px;
  border-bottom: 1px solid #D5DCDF;
  gap: 16px;
}
.page-wrapper .main-section .list-tabs .list-tabs__tab {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: center;
  color: var(--color-gray-800, #626E75);
}
.page-wrapper .main-section .list-tabs .list-tabs__tab.active {
  color: #000000;
  border-bottom: 2px solid #000000;
}
.page-wrapper .briefs-table .ant-checkbox-wrapper {
  display: none;
}
.page-wrapper .briefs-table__selected td.ant-table-cell {
  border-top: 2px solid #96BAE4;
  border-bottom: 2px solid #96BAE4;
}
.page-wrapper .briefs-table__selected td.ant-table-cell:nth-child(2) {
  border-left: 2px solid #96BAE4;
}
.page-wrapper .briefs-table__selected td.ant-table-cell:last-child {
  border-right: 2px solid #96BAE4;
}
.page-wrapper .briefs-table__color-yellow td.ant-table-cell:nth-child(2) {
  border-left: 2px solid #FFE49D;
}
.page-wrapper .briefs-table__color-green td.ant-table-cell:nth-child(2) {
  border-left: 2px solid #78D998;
}
.page-wrapper .briefs-table__validated_date {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #FF9736;
}
.page-wrapper .side-section {
  width: 636px;
  min-width: 454px;
  background: #fff;
  box-shadow: 0 -1px 6px 0 rgba(0, 0, 0, 0.1019607843);
  height: calc(100vh - 48px);
  overflow-y: auto;
  position: sticky;
  top: 48px;
  z-index: 12;
}
.page-wrapper .side-section__close {
  cursor: pointer;
  position: absolute;
  right: 24px;
  top: 16px;
  z-index: 1;
}
.page-wrapper.manager-tasks {
  padding-bottom: 50px;
}
.page-wrapper.manager-tasks .side-section {
  height: calc(100% - 40px);
  padding-bottom: 16px;
  position: fixed;
  right: 0;
  top: 48px;
  z-index: 12;
}
.page-wrapper.tasks .side-section {
  height: calc(100% - 40px);
  padding-bottom: 16px;
  position: fixed;
  right: 0;
  top: 48px;
}

.text--strong {
  font-weight: 600;
}

.info__empty {
  width: 100%;
  height: 118px;
  top: 69px;
  left: 1290px;
  padding: 40px 24px 40px 24px;
  gap: 10px;
  border-radius: 6px;
  background: #F6F6F6;
  text-align: center;
}
.info__empty-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.15px;
  text-align: center;
  color: #7E8681;
}
.info__empty-wrapper {
  padding: 20px;
}

.brief-page .action-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  text-align: left;
  color: #092A3A;
}
.brief-page .form-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  color: #092A3A;
}

.task-page-wrapper .main-section {
  padding: 24px 32px;
  flex: 1 1;
  overflow-y: auto;
}

.back-link {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  text-align: left;
  color: #000;
}

.layout__accept-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 19.07px;
  text-align: left;
}
.layout__title-text {
  font-size: 12px;
  font-weight: 600;
  line-height: 13.2px;
  text-align: left;
  color: #074DA1;
}
.layout__title-description {
  font-size: 8px;
  font-weight: 600;
  line-height: 8.8px;
  text-align: left;
  color: #85929A;
}

.layout-header {
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
}

.ant-layout-sider.layout-sider {
  overflow: auto;
  height: 100vh;
  position: fixed;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  scrollbar-width: thin;
  scrollbar-color: unset;
  padding-top: 48px;
  background: #fff;
}

.delete-button {
  display: flex;
  cursor: pointer;
}

.icon__left {
  transform: rotate(180deg);
}

.media-factors__file {
  font-size: 12px;
}
.media-factors__comments {
  cursor: pointer;
}

.has-error {
  color: #ff4d4f;
}

.selected-task-row {
  background: #FFEEEB;
}

.accepted-task-row {
  background: #F6FCF8;
}
.accepted-task-row .ant-table-cell {
  background: #F6FCF8;
}

.manager-tasks__file {
  padding: 4px 8px 6px 6px;
  gap: 6px;
  border-radius: 6px;
  background: #EFF5FF;
  cursor: pointer;
}
.manager-tasks__file-name .ant-typography {
  color: #1066CB;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.manager-tasks__popover {
  width: 160px;
}
.manager-tasks__popover-item {
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #384146;
  cursor: pointer;
}
.manager-tasks__popover-item_red {
  color: #DE1E04;
}
@media (max-width: 1600px) {
  .manager-tasks__channels.ant-select.ant-select-in-form-item {
    width: 350px;
  }
}
@media (min-width: 1600px) {
  .manager-tasks__channels.ant-select.ant-select-in-form-item {
    width: 600px;
  }
}

.layout-sider__links a.active {
  background: #EFF5FF;
}

.sider-links__popover .ant-popover-inner {
  background: #000;
  padding: 6px;
  border-radius: 4px;
}
.sider-links__popover .ant-popover-arrow:before {
  background: #000;
}
.sider-links__popover .ant-popover-inner-content {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/assets/description.scss","webpack://./src/assets/main.scss","webpack://./src/assets/statuses.scss","webpack://./src/assets/stages.scss","webpack://./src/assets/criterions.scss","webpack://./src/assets/commentaries.scss","webpack://./src/assets/planner.scss","webpack://./src/assets/factorChannels.scss","webpack://./src/assets/report.scss","webpack://./src/assets/admin.scss","webpack://./src/assets/workgroup.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;ACAR;ADGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ACDR;ADGQ;EACI,cAAA;ACDZ;ADKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;ACHR;;ADQI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;ACLR;ADcI;EACI,cAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ACZR;ADeI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;ACbR;ADgBI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ACdR;ADkBQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AChBZ;;ADqBA;EACI,aAAA;EACA,iBAAA;EACA,SAAA;AClBJ;ADoBI;EACI,WAAA;EACA,4BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AClBR;ADqBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;ACnBR;;ADuBA;EACI,0BAAA;EACA,yBAAA;ACpBJ;;ADuBA;EACI,wBAAA;EACA,WAAA;ACpBJ;;ADuBA;EACI,UAAA;EACA,mBAAA;ACpBJ;;ADuBA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;ACpBJ;;ADuBA;EACI,aAAA;ACpBJ;;ADuBA;EACI,UAAA;ACpBJ;;AC1HI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AD6HR;AC3HQ;EACI,qBAAA;AD6HZ;ACzHI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AD2HR;ACzHQ;EACI,cAAA;AD2HZ;ACtHQ;EACI,cAAA;ADwHZ;ACrHQ;EACI,qBAAA;ADuHZ;ACnHI;EACI,aAAA;EACA,QAAA;EACA,mBAAA;ADqHR;;AE1JI;EACI,gBAAA;EACA,QAAA;AF6JR;AE3JQ;EACI,YAAA;EACA,wBAAA;AF6JZ;AE1JQ;EACI,2BAAA;EACA,mBAAA;AF4JZ;AE1JY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AF4JhB;AEzJY;EACI,0BAAA;EACA,mBAAA;AF2JhB;AExJY;EACI,OAAA;EACA,WAAA;AF0JhB;AExJgB;EACI,WAAA;AF0JpB;AEpJI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AFsJR;AEpJQ;EACI,mBAAA;EACA,yBAAA;AFsJZ;AEpJY;EACI,mBAAA;AFsJhB;AElJQ;EACI,mBAAA;EACA,yBAAA;AFoJZ;AElJY;EACI,mBAAA;AFoJhB;AEjJY;EACI,mBAAA;AFmJhB;AE/IQ;EACI,mBAAA;EACA,yBAAA;AFiJZ;AE7IY;EACI,cAAA;AF+IhB;AE5IY;EACI,mBAAA;AF8IhB;AE3IY;EACI,mBAAA;AF6IhB;AExIY;EACI,cAAA;AF0IhB;AEtIQ;EACI,yBAAA;AFwIZ;AEpII;EACI,wBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AFsIR;AEnII;EACI,wBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AFqIR;AEnIQ;EACI,mBAAA;EACA,WAAA;AFqIZ;AElIQ;EACI,mBAAA;EACA,cAAA;AFoIZ;AEhII;EACI,WAAA;AFkIR;AE/HI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AFiIR;AE7QA;EA+II;;;;;;IAAA;AFuIJ;;AE9HA;EACI,SAAA;AFiIJ;;AGzRI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AH4RR;AGzRI;EACI,wBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AH2RR;AGzRQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AH2RZ;AGxRQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AH0RZ;AGtRI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AHwRR;AGrRI;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AHuRR;AGrRQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AHuRZ;AGpRQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AHsRZ;AGlRI;EACI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AHoRR;AGjRI;EACI,UAAA;EACA,UAAA;EACA,4BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AHmRR;AGhRI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AHkRR;AG/QI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,0BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AHiRR;;AG7QA;EACI,YAAA;EACA,4BAAA;AHgRJ;;AG9QA;EACI,YAAA;EACA,wBAAA;EACA,yCAAA;AHiRJ;;AG/QA;EACI,aAAA;EACA,wBAAA;AHkRJ;;AGhRA;EACI,YAAA;EACA,4BAAA;EACA,yCAAA;AHmRJ;;AGhRA;EACI,6BAAA;AHmRJ;;AGjRA;EACI,wBAAA;EACA,2BAAA;AHoRJ;;AGlRA;EACI,wBAAA;AHqRJ;;AGnRA;EACI,6BAAA;EACA,2BAAA;AHsRJ;;AI3aI;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;AJ8aR;AI3aI;EACI,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AJ6aR;AI1aI;EACI,gBAAA;EACA,eAAA;AJ4aR;AIzaI;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AJ2aR;AIxaI;EACI,WAAA;AJ0aR;AIvaI;EACI,WAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AJyaR;AIvaQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AJyaZ;AItaQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AJwaZ;AIraQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AJuaZ;AIpaQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AJsaZ;AInaQ;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AJqaZ;AIlaQ;EACI,mBAAA;EACA,WAAA;AJoaZ;AIjaQ;EACI,eAAA;AJmaZ;AI/ZY;EACI,aAAA;AJiahB;AI5ZI;EACI,6BAAA;AJ8ZR;AI3ZI;EACI,iBAAA;AJ6ZR;AI3ZQ;EACI,eAAA;AJ6ZZ;AI1ZQ;EACI,gBAAA;AJ4ZZ;AIxZI;EACI,aAAA;AJ0ZR;AIxZQ;EACI,eAAA;AJ0ZZ;;AKphBI;EACI,cAAA;ALuhBR;AKphBI;EACI,yBAAA;EACA,sBAAA;ALshBR;AKnhBI;EACI,gCAAA;ALqhBR;AKlhBI;EACI,+BAAA;ALohBR;AKjhBI;EACI,mBAAA;ALmhBR;AKhhBI;EACI,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;ALkhBR;AK/gBI;EACI,cAAA;EACA,YAAA;ALihBR;;AK7gBA;EACI,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;ALghBJ;AK9gBI;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;ALghBR;AK9gBQ;EACI,yBAAA;ALghBZ;AK7gBQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AL+gBZ;AK7gBY;EACI,cAAA;AL+gBhB;AK5gBY;EACI,cAAA;AL8gBhB;AKzgBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AL2gBR;AKzgBQ;EACI,cAAA;AL2gBZ;AKxgBQ;EACI,cAAA;AL0gBZ;;AKrgBA;EACI,6BAAA;EACA,gBAAA;ALwgBJ;;AKrgBA;EACI,6BAAA;EACA,iBAAA;ALwgBJ;AKtgBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ALwgBR;AKrgBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ALugBR;AKpgBI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;ALsgBR;AKngBI;EACI,WAAA;EACA,eAAA;ALqgBR;AKngBQ;EACI,iBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ALqgBZ;AKlgBQ;EACI,yBAAA;EACA,sBAAA;ALogBZ;AKjgBQ;EACI,+BAAA;ALmgBZ;AKhgBQ;EACI,gCAAA;ALkgBZ;AK/fQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;ALigBZ;AK/fY;EACI,aAAA;EACA,yBAAA;ALigBhB;AK7fQ;EACI,mBAAA;EACA,cAAA;AL+fZ;AK5fQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AL8fZ;AK3fQ;EACI,YAAA;EACA,uBAAA;EACA,yBAAA;AL6fZ;AK1fQ;EACI,iBAAA;AL4fZ;AKxfI;EACI,cAAA;EACA,eAAA;AL0fR;AKvfI;EACI,eAAA;ALyfR;AKrfQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;ALufZ;AKlfQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ALofZ;AKjfQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ALmfZ;AKhfQ;EACI,eAAA;ALkfZ;AK5eY;EACI,WAAA;AL8ehB;;AKveI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AL0eR;AKveI;EACI,YAAA;EACA,aAAA;EACA,qCAAA;ALyeR;AKteI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;ALweR;AKreI;EACI,cAAA;ALueR;AKpeI;EACI,gBAAA;ALseR;AKpeQ;EACI,kBAAA;ALseZ;AKleI;EACI,cAAA;ALoeR;AKjeI;EACI,+BAAA;EACA,8BAAA;EACA,gBAAA;ALmeR;;AK5dY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AL+dhB;AK5dY;EACI,gBAAA;AL8dhB;AK1dgB;EACI,8BAAA;AL4dpB;AKzdgB;EACI,+BAAA;AL2dpB;AKrdY;EACI,gBAAA;EACA,mBAAA;ALudhB;AKndQ;EACI,WAAA;ALqdZ;AKldQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;ALodZ;AKhdY;EACI,yBAAA;EACA,kBAAA;ALkdhB;AK/cY;EACI,4BAAA;EACA,0BAAA;ALidhB;;AK1cI;EACI,oBAAA;AL6cR;AK3cI;EACI,8BAAA;EACA,YAAA;EACA,oBAAA;AL6cR;;AKrcI;EACI,cAAA;ALwcR;AKrcI;EACI,gBAAA;EACA,eAAA;ALucR;AKpcI;EACI,8BAAA;ALscR;;AKjcI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ALocR;AKjcI;EACI,gCAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ALmcR;AK/bI;EACI,cAAA;ALicR;AK9bI;EACI,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;ALgcR;AK7bI;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AL+bR;;AK1bI;EACI,cAAA;EACA,eAAA;AL6bR;AK3bQ;EACI,cAAA;AL6bZ;;AKxbA;EACI,gBAAA;AL2bJ;;AKxbA;EACI,UAAA;AL2bJ;;AKxbA;EACI,iCAAA;AL2bJ;;AKvbI;;;EAGI,gBAAA;AL0bR;;AKtbA;EACI;IACI,2CAAA;ELybN;EKvbE;IACI,6CAAA;ELybN;EKvbE;IACI,2CAAA;ELybN;AACF;AMt4BA;EACI,kBAAA;EACA,mBAAA;ANw4BJ;AMt4BI;EACI,yBAAA;EACA,sBAAA;ANw4BR;AMr4BI;EACI,gCAAA;ANu4BR;AMp4BI;EACI,6BAAA;ANs4BR;AMn4BI;EACI,+BAAA;ANq4BR;AMl4BI;EACI,mBAAA;ANo4BR;AMj4BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;ANm4BR;AMh4BI;EACI,sBAAA;ANk4BR;AM/3BI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ANi4BR;AM93BI;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ANg4BR;AM53BI;EACI,mBAAA;AN83BR;AM33BI;EACI,sBAAA;AN63BR;AM33BQ;EACI,cAAA;AN63BZ;AMz3BI;EACI,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;AN23BR;;AMv3BA;EACI,oCAAA;EACA,sCAAA;AN03BJ;;AOv8BI;EACI,kBAAA;EACA,YAAA;AP08BR;AOx8BQ;EACI,8BAAA;AP08BZ;AOx8BY;EACI,eAAA;AP08BhB;AOv8BY;EACI,gBAAA;EACA,WAAA;APy8BhB;AOl8BY;EACI,eAAA;APo8BhB;AO/7BI;EACI,cAAA;APi8BR;AO97BI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;APg8BR;AO97BQ;EACI,WAAA;EACA,YAAA;APg8BZ;;AO17BI;EACI,gBAAA;EACA,eAAA;AP67BR;AO17BI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AP47BR;AOz7BI;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AP27BR;;AQ7gCI;EACI,WAAA;ARghCR;;ASjhCI;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;ATohCR;ASjhCI;EACI,YAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;ATmhCR;AShhCI;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;ATkhCR;AS/gCI;EACI,gBAAA;ATihCR;AS9gCI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;ATghCR;AS7gCI;EACI,eAAA;EACA,eAAA;AT+gCR;AS5gCI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;AT8gCR;AS5gCQ;EACI,gBAAA;AT8gCZ;AS3gCQ;EACI,WAAA;AT6gCZ;;AA5jCA;EACI,wBAAA;EACA,kBAAA;EACA,wIAAA;AA+jCJ;AA5jCA;EACI,+CAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,SAAA;AA8jCJ;;AA3jCA;EACI,+CAAA;AA8jCJ;AA5jCI;EACI,mDAAA;AA8jCR;AA3jCI;EACI,mDAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AA6jCR;AAzjCQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AA2jCZ;AAvjCI;EACI,oCAAA;AAyjCR;AAtjCI;EACI,kBAAA;AAwjCR;AArjCI;EACI,SAAA;AAujCR;AApjCI;EACI,WAAA;AAsjCR;AAljCQ;EACI,yBAAA;AAojCZ;AAhjCI;EACI,yBAAA;EACA,qBAAA;AAkjCR;AAhjCQ;EACI,yBAAA;EACA,qBAAA;AAkjCZ;AA9iCI;EACI,oCAAA;EACA,YAAA;EACA,qBAAA;AAgjCR;AA7iCI;EACI,qCAAA;EACA,qBAAA;AA+iCR;AA5iCI;EACI,mBAAA;EACA,cAAA;AA8iCR;AA5iCQ;EACI,mBAAA;AA8iCZ;AA3iCQ;EACI,gBAAA;AA6iCZ;AA1iCQ;EACI,mBAAA;AA4iCZ;AAziCQ;EACI,8BAAA;AA2iCZ;AAxiCQ;EACI,mBAAA;AA0iCZ;AAviCQ;EACI,+BAAA;AAyiCZ;AAriCI;EACI,YAAA;AAuiCR;AApiCI;EACI,eAAA;AAsiCR;;AAjiCI;EACI,yBAAA;EACA,qBAAA;AAoiCR;AAliCQ;EACI,yBAAA;EACA,qBAAA;AAoiCZ;AAhiCI;EACI,oCAAA;EACA,YAAA;EACA,qBAAA;AAkiCR;AA/hCI;EACI,qCAAA;EACA,qBAAA;AAiiCR;;AA3hCQ;EACI,gBAAA;EACA,6BAAA;EACA,gCAAA;AA8hCZ;AA3hCQ;EACI,gBAAA;AA6hCZ;AA1hCQ;EACI,8BAAA;AA4hCZ;AAzhCQ;EACI,+BAAA;AA2hCZ;;AAthCA;EACI,+BAAA;AAyhCJ;AAxhCI;EACI,WAAA;EACA,YAAA;AA0hCR;AA9hCA;EAOI,2BAAA;AA0hCJ;AAzhCI;EACI,sEAAA;EACA,kBAAA;AA2hCR;AAriCA;EAaI,2BAAA;AA2hCJ;AA1hCI;EACI,sBAAA;EACA,sBAAA;AA4hCR;AA5iCA;EAmBI,4BAAA;AA4hCJ;AA3hCI;EACI,yBAAA;EACA,kBAAA;AA6hCR;AAnjCA;EAyBI,oDAAA;AA6hCJ;AA5hCI;EACI,yBAAA;AA8hCR;AA3hCI;EACI,mBAAA;AA6hCR;;AAxhCI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AA2hCR;AAxhCI;EACI,cAAA;AA0hCR;AAvhCI;EACI,aAAA;AAyhCR;AAthCI;EACI,mBAAA;AAwhCR;;AAphCA;EACI,qBAAA;EACA,wCAAA;AAuhCJ;;AAnhCI;EACI,gBAAA;AAshCR;;AAlhCA;EACI,aAAA;EACA,WAAA;AAqhCJ;AAnhCI;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;AAqhCR;AAnhCQ;EACI,YAAA;EACA,gCAAA;EACA,SAAA;AAqhCZ;AAnhCY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;AAqhChB;AAnhCgB;EACI,cAAA;EACA,gCAAA;AAqhCpB;AA9gCQ;EACI,aAAA;AAghCZ;AA7gCQ;EACI,6BAAA;EACA,gCAAA;AA+gCZ;AA7gCY;EACI,8BAAA;AA+gChB;AA5gCY;EACI,+BAAA;AA8gChB;AAzgCY;EACI,8BAAA;AA2gChB;AAtgCY;EACI,8BAAA;AAwgChB;AApgCQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAsgCZ;AAlgCI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oDAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAogCR;AAlgCQ;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAogCZ;AAhgCI;EACI,oBAAA;AAkgCR;AAhgCQ;EACI,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AAkgCZ;AA7/BQ;EACI,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AA+/BZ;;AAz/BI;EACI,gBAAA;AA4/BR;;AAv/BI;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,4BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA0/BR;AAv/BI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAy/BR;AAt/BI;EACI,aAAA;AAw/BR;;AAn/BI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAs/BR;AAn/BI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAq/BR;;AAh/BI;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;AAm/BR;;AA/+BA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AAk/BJ;;AA9+BI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAi/BR;AA9+BI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAg/BR;AA7+BI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA++BR;;AA1+BA;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AA6+BJ;;AA1+BA;EACI,cAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,MAAA;EACA,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AA6+BJ;;AA1+BA;EACI,aAAA;EACA,eAAA;AA6+BJ;;AA1+BA;EACI,yBAAA;AA6+BJ;;AAz+BI;EACI,eAAA;AA4+BR;AAz+BI;EACI,eAAA;AA2+BR;;AAv+BA;EACI,cAAA;AA0+BJ;;AAv+BA;EACI,mBAAA;AA0+BJ;;AAv+BA;EACI,mBAAA;AA0+BJ;AAx+BI;EACI,mBAAA;AA0+BR;;AAr+BI;EACI,wBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAw+BR;AAp+BQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAs+BZ;AAl+BI;EACI,YAAA;AAo+BR;AAj+BI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAm+BR;AAj+BQ;EACI,cAAA;AAm+BZ;AA99BQ;EACI;IACI,YAAA;EAg+Bd;AACF;AA79BQ;EACI;IACI,YAAA;EA+9Bd;AACF;;AAx9BQ;EACI,mBAAA;AA29BZ;;AAr9BI;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;AAw9BR;AAr9BI;EACI,gBAAA;AAu9BR;AAp9BI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AAs9BR","sourcesContent":[".description {\n    &__wrapper {\n        display: grid;\n        gap: 24px;\n        padding: 12px 20px;\n    }\n\n    &__item {\n        display: grid;\n        grid-template-columns: 1fr 2fr;\n        align-items: center;\n\n        &-link {\n            color: #000000;\n        }\n    }\n\n    &__item-title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0.1px;\n        text-align: left;\n        color: #7F8681;\n    }\n}\n\n.brief-description {\n    &__title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0.1px;\n        text-align: left;\n        color: #326AAB;\n    }\n\n    &__text {\n\n    }\n}\n\n.file {\n    &__item {\n        padding: 8px 0;\n        gap: 8px;\n        border-radius: 6px;\n        border-bottom: 1px solid #E3E9E5;\n        background: #fff;\n        width: 100%;\n        cursor: pointer;\n    }\n\n    &__item-type {\n        width: 48px;\n        height: 48px;\n        border-radius: 8px;\n        border: 1px solid #1F9A4833;\n        background: #DEF9E6;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #1F9A48;\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 17.7px;\n        text-align: left;\n        text-transform: uppercase;\n    }\n\n    &__item-name {\n        color: #000;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        text-align: left;\n    }\n\n    &__item-info {\n        &__description {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 16px;\n            letter-spacing: 0.15px;\n            text-align: left;\n            color: #7E8681;\n        }\n    }\n}\n\n.criteria {\n    display: flex;\n    flex-flow: column;\n    gap: 12px;\n\n    &__card {\n        width: 100%;\n        padding: 12px 16px 16px 16px;\n        gap: 16px;\n        border-radius: 6px;\n        background: #F7F7F7;\n        display: flex;\n        flex-flow: column;\n    }\n\n    &__card-title {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0;\n        text-align: left;\n    }\n}\n\n.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {\n    padding-inline-start: 10px;\n    padding-inline-end: unset;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {\n    margin-inline-end: unset;\n    flex: unset;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    padding: 0;\n    align-items: center;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    letter-spacing: 0.1px;\n    text-align: left;\n    color: #7F8681;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {\n    fill: #7F8681;\n}\n\n.ant-collapse .ant-collapse-content > .ant-collapse-content-box {\n    padding: 0;\n}\n","@import \"description\";\n@import \"statuses\";\n@import \"stages\";\n@import \"criterions\";\n@import \"commentaries\";\n@import \"planner\";\n@import \"factorChannels\";\n@import \"report\";\n@import \"admin\";\n@import \"workgroup\";\n\n@font-face {\n    font-family: 'Open Sans';\n    font-display: auto;\n    src: local('Arvo'), url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap) format('woff2');\n}\n\nbody {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-optical-sizing: auto;\n    font-weight: 400;\n    font-style: normal;\n    font-variation-settings: \"wdth\" 100;\n    margin: 0;\n}\n\n.ant-layout {\n    font-family: \"Open Sans\", sans-serif !important;\n\n    .ant-layout-sider {\n        box-shadow: 1px 0 6px 0 #0000001A;\n    }\n\n    .ant-layout-header {\n        box-shadow: 0 1px 6px 0 #0000001A;\n        z-index: 100;\n        justify-content: center;\n        height: 48px;\n        padding: 0 16px;\n    }\n\n    .ant-table-wrapper {\n        .ant-table-thead > tr > th {\n            font-size: 12px;\n            font-weight: 400;\n            color: #7E8681;\n            font-family: \"Open Sans\", sans-serif;\n        }\n    }\n\n    .ant-table-cell, .ant-typography {\n        font-family: \"Open Sans\", sans-serif;\n    }\n\n    .ant-card.card-middle .ant-card-body {\n        padding: 12px 24px;\n    }\n\n    .ant-typography {\n        margin: 0;\n    }\n\n    .ant-upload.ant-upload-select {\n        width: 100%;\n    }\n\n    .ant-form-item-has-error {\n        textarea {\n            border: 1px solid #ff4d4f;\n        }\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n        background-color: #7E8681;\n        border-color: #7E8681;\n\n        &:hover {\n            background-color: #7E8681;\n            border-color: #7E8681;\n        }\n    }\n\n    .ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {\n        background-color: #7E8681 !important;\n        opacity: 0.8;\n        border-color: #7E8681;\n    }\n\n    .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {\n        /*background-color: #fff !important;*/\n        border-color: #7E8681;\n    }\n\n    .ant-segmented.segmented.ant-segmented-sm {\n        border-radius: 16px;\n        display: block;\n\n        .ant-segmented-item {\n            border-radius: 16px;\n        }\n\n        .ant-segmented-item-label {\n            min-height: 14px;\n        }\n\n        .ant-segmented-thumb {\n            border-radius: 16px;\n        }\n\n        &.criterion-null {\n            background: rgb(239, 239, 239);\n        }\n\n        &.criterion-true {\n            background: #19bb4f;\n        }\n\n        &.criterion-false {\n            background: rgba(0, 0, 0, 0.25);\n        }\n    }\n\n    .ant-tabs-content, .ant-tabs-tabpane {\n        height: 100%;\n    }\n\n    .ant-tabs-nav {\n        padding: 0 20px;\n    }\n}\n\n.ant-popover {\n    .ant-checkbox-checked .ant-checkbox-inner {\n        background-color: #7E8681;\n        border-color: #7E8681;\n\n        &:hover {\n            background-color: #7E8681;\n            border-color: #7E8681;\n        }\n    }\n\n    .ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {\n        background-color: #7E8681 !important;\n        opacity: 0.8;\n        border-color: #7E8681;\n    }\n\n    .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {\n        /*background-color: #fff !important;*/\n        border-color: #7E8681;\n    }\n}\n\n.ant-table-wrapper .ant-table-tbody {\n    .ant-table-row.ant-table-row-selected {\n        > .ant-table-cell {\n            background: #fff;\n            border-top: 2px solid #96BAE4;\n            border-bottom: 2px solid #96BAE4;\n        }\n\n        .ant-table-cell-row-hover {\n            background: #fff;\n        }\n\n        > .ant-table-cell:nth-child(2) {\n            border-left: 2px solid #96BAE4;\n        }\n\n        > .ant-table-cell:last-child {\n            border-right: 2px solid #96BAE4;\n        }\n    }\n}\n\n.ant-table-content {\n    /* Define the scrollbar style */\n    &::-webkit-scrollbar {\n        width: 10px;\n        height: 10px;\n    }\n\n    /* Define the thumb style */\n    &::-webkit-scrollbar-thumb {\n        background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);\n        border-radius: 5px;\n    }\n\n    /* Define the track style */\n    &::-webkit-scrollbar-track {\n        background-color: #ddd;\n        border: 1px solid #ccc;\n    }\n\n    /* Define the button style */\n    &::-webkit-scrollbar-button {\n        background-color: #4d7fff;\n        border-radius: 5px;\n    }\n\n    /* Define the button style when being hovered over */\n    &::-webkit-scrollbar-button:hover {\n        background-color: #999999;\n    }\n\n    .ant-table-row.selected {\n        background: #e6e6e6;\n    }\n}\n\n.ant-tabs-nav-wrap {\n    .ant-tabs-tab-btn {\n        display: flex;\n        align-items: center;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0.4px;\n        text-align: left;\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n        color: #000000;\n    }\n\n    .ant-tabs-tab-icon {\n        display: flex;\n    }\n\n    .ant-tabs-ink-bar {\n        background: #000000;\n    }\n}\n\n.ant-table-content {\n    scrollbar-width: thin;\n    scrollbar-color: rgb(0 0 0 / 30%) #fff;\n}\n\n.ant-table-cell {\n    .ant-form-item .ant-form-item-control-input {\n        min-height: 20px;\n    }\n}\n\n.page-wrapper {\n    display: flex;\n    width: 100%;\n\n    .main-section {\n        padding: 24px 32px;\n        flex: 1;\n        overflow-y: hidden;\n\n        .list-tabs {\n            height: 28px;\n            border-bottom: 1px solid #D5DCDF;\n            gap: 16px;\n\n            .list-tabs__tab {\n                font-size: 14px;\n                font-weight: 600;\n                line-height: 16px;\n                letter-spacing: 0.4px;\n                text-align: center;\n                color: var(--color-gray-800, #626E75);\n\n                &.active {\n                    color: #000000;\n                    border-bottom: 2px solid #000000;\n                }\n            }\n        }\n    }\n\n    .briefs-table {\n        .ant-checkbox-wrapper {\n            display: none;\n        }\n\n        &__selected td.ant-table-cell {\n            border-top: 2px solid #96BAE4;\n            border-bottom: 2px solid #96BAE4;\n\n            &:nth-child(2) {\n                border-left: 2px solid #96BAE4;\n            }\n\n            &:last-child {\n                border-right: 2px solid #96BAE4;\n            }\n        }\n\n        &__color-yellow {\n            td.ant-table-cell:nth-child(2) {\n                border-left: 2px solid #FFE49D;\n            }\n        }\n\n        &__color-green {\n            td.ant-table-cell:nth-child(2) {\n                border-left: 2px solid #78D998;\n            }\n        }\n\n        &__validated_date {\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            text-align: left;\n            color: #FF9736;\n        }\n    }\n\n    .side-section {\n        width: 636px;\n        min-width: 454px;\n        background: #fff;\n        box-shadow: 0 -1px 6px 0 rgba(0, 0, 0, 0.1019607843);\n        height: calc(100vh - 48px);\n        overflow-y: auto;\n        position: sticky;\n        top: 48px;\n        z-index: 12;\n\n        &__close {\n            cursor: pointer;\n            position: absolute;\n            right: 24px;\n            top: 16px;\n            z-index: 1;\n        }\n    }\n\n    &.manager-tasks {\n        padding-bottom: 50px;\n\n        .side-section {\n            height: calc(100% - 40px);\n            padding-bottom: 16px;\n            position: fixed;\n            right: 0;\n            top: 48px;\n            z-index: 12;\n        }\n    }\n\n    &.tasks {\n        .side-section {\n            height: calc(100% - 40px);\n            padding-bottom: 16px;\n            position: fixed;\n            right: 0;\n            top: 48px;\n        }\n    }\n}\n\n.text {\n    &--strong {\n        font-weight: 600;\n    }\n}\n\n.info {\n    &__empty {\n        width: 100%;\n        height: 118px;\n        top: 69px;\n        left: 1290px;\n        padding: 40px 24px 40px 24px;\n        gap: 10px;\n        border-radius: 6px;\n        background: #F6F6F6;\n        text-align: center;\n    }\n\n    &__empty-text {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 19px;\n        letter-spacing: 0.15px;\n        text-align: center;\n        color: #7E8681;\n    }\n\n    &__empty-wrapper {\n        padding: 20px;\n    }\n}\n\n.brief-page {\n    .action-title {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 21.79px;\n        text-align: left;\n        color: #092A3A;\n    }\n\n    .form-title {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 18px;\n        text-align: left;\n        color: #092A3A;\n    }\n}\n\n.task-page-wrapper {\n    .main-section {\n        padding: 24px 32px;\n        flex: 1;\n        overflow-y: auto;\n    }\n}\n\n.back-link {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 19.07px;\n    text-align: left;\n    color: #000;\n}\n\n.layout {\n    &__accept-text {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 19.07px;\n        text-align: left;\n    }\n\n    &__title-text {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 13.2px;\n        text-align: left;\n        color: #074DA1;\n    }\n\n    &__title-description {\n        font-size: 8px;\n        font-weight: 600;\n        line-height: 8.8px;\n        text-align: left;\n        color: #85929A;\n    }\n}\n\n\n.layout-header {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.ant-layout-sider.layout-sider {\n    overflow: auto;\n    height: 100vh;\n    position: fixed;\n    inset-inline-start: 0;\n    top: 0;\n    bottom: 0;\n    scrollbar-width: thin;\n    scrollbar-color: unset;\n    padding-top: 48px;\n    background: #fff;\n}\n\n.delete-button {\n    display: flex;\n    cursor: pointer;\n}\n\n.icon__left {\n    transform: rotate(180deg);\n}\n\n.media-factors {\n    &__file {\n        font-size: 12px;\n    }\n\n    &__comments {\n        cursor: pointer;\n    }\n}\n\n.has-error {\n    color: #ff4d4f;\n}\n\n.selected-task-row {\n    background: #FFEEEB;\n}\n\n.accepted-task-row {\n    background: #F6FCF8;\n\n    .ant-table-cell {\n        background: #F6FCF8;\n    }\n}\n\n.manager-tasks {\n    &__file {\n        padding: 4px 8px 6px 6px;\n        gap: 6px;\n        border-radius: 6px;\n        background: #EFF5FF;\n        cursor: pointer;\n    }\n\n    &__file-name {\n        .ant-typography {\n            color: #1066CB;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 18px;\n        }\n    }\n\n    &__popover {\n        width: 160px;\n    }\n\n    &__popover-item {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 18px;\n        letter-spacing: -0.02em;\n        color: #384146;\n        cursor: pointer;\n\n        &_red {\n            color: #DE1E04;\n        }\n    }\n\n    &__channels {\n        @media (max-width: 1600px) {\n            &.ant-select.ant-select-in-form-item {\n                width: 350px;\n            }\n        }\n\n        @media (min-width: 1600px) {\n            &.ant-select.ant-select-in-form-item {\n                width: 600px;\n            }\n        }\n    }\n}\n\n.layout-sider {\n    &__links {\n        a.active {\n            background: #EFF5FF;\n        }\n    }\n}\n\n.sider-links__popover {\n    .ant-popover-inner {\n        background: #000;\n        padding: 6px;\n        border-radius: 4px;\n    }\n\n    .ant-popover-arrow:before {\n        background: #000;\n    }\n\n    .ant-popover-inner-content {\n        color: #fff;\n        font-size: 12px;\n        font-weight: 600;\n    }\n}\n",".status-bar {\n    &__number {\n        width: 24px;\n        height: 24px;\n        border-radius: 12px;\n        border: 2px solid #7E8681;\n\n        &.disabled {\n            border-color: #D5DCDF;\n        }\n    }\n\n    &__text {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        text-align: left;\n        color: #7E8681;\n        white-space: nowrap;\n\n        &.disabled {\n            color: #D5DCDF;\n        }\n    }\n\n    &__item.active {\n        .status-bar__text {\n            color: #000000;\n        }\n\n        .status-bar__number {\n            border-color: #000000;\n        }\n    }\n\n    &__link {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n    }\n}\n",".stages {\n    &__items {\n        overflow-y: auto;\n        gap: 2px;\n\n        .ant-picker-outlined {\n            height: 24px;\n            padding: 2px 7px 2px 7px;\n        }\n\n        .ant-picker-input {\n            flex-direction: row-reverse;\n            align-items: center;\n\n            input {\n                font-size: 12px;\n                font-weight: 600;\n                line-height: 18px;\n                text-align: center;\n                color: #384146;\n            }\n\n            .ant-picker-suffix {\n                margin-inline-start: unset;\n                padding-bottom: 1px;\n            }\n\n            .ant-picker-clear {\n                left: 0;\n                width: 10px;\n\n                svg {\n                    width: 10px;\n                }\n            }\n        }\n    }\n\n    &__item {\n        width: 100%;\n        border-radius: 6px;\n        padding: 5px;\n        background: #FAFAFA;\n        border: 1px solid #FAFAFA;\n        cursor: pointer;\n\n        &.completed {\n            background: #F6FCF8;\n            border: 1px solid #f6fcf8;\n\n            &:not(.advance) .stages__fact-date .ant-picker-outlined {\n                background: #DBF4E3;\n            }\n        }\n\n        &.in-work {\n            background: #FFFCEB;\n            border: 1px solid #FFFCEB;\n\n            .stages__fact-date .ant-picker-outlined {\n                background: #F3F6F8;\n            }\n\n            .stages__item-duration {\n                background: #F3F6F8;\n            }\n        }\n\n        &.expired {\n            background: #FFEEEB;\n            border: 1px solid #FFEEEB;\n        }\n\n        &.overdue:not(.not-started) {\n            .stages__item-text .ant-typography, .stages__date-diff {\n                color: #C11801;\n            }\n\n            .stages__fact-date .ant-picker-outlined {\n                background: #FFEEEB;\n            }\n\n            .stages__item-duration {\n                background: #FFEEEB;\n            }\n        }\n\n        &.advance:not(.not-started) {\n            .stages__item-text .ant-typography, .stages__date-diff {\n                color: #1066CB;\n            }\n        }\n\n        &.stages__item_filtered {\n            border: 1px solid #85929A;\n        }\n    }\n\n    &__item-duration {\n        padding: 2px 8px 4px 8px;\n        gap: 6px;\n        border-radius: 4px;\n        background: #fff;\n        font-size: 11px;\n        font-weight: 600;\n        line-height: 18px;\n        text-align: center;\n        color: #384146;\n    }\n\n    &__item-manager {\n        padding: 2px 8px 4px 8px;\n        gap: 6px;\n        border-radius: 4px;\n        background: #F3F6F8;\n        font-size: 11px;\n        font-weight: 600;\n        line-height: 18px;\n        text-align: center;\n        color: #384146;\n        cursor: pointer;\n\n        &_current {\n            background: #384146;\n            color: #fff;\n        }\n\n        &_expired {\n            background: #FFBFB7;\n            color: #384146;\n        }\n    }\n\n    &__item-content {\n        width: 100%;\n    }\n\n    &__item-text {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n    }\n\n    /*&__item-date-text {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 18px;\n        text-align: left;\n        color: #7E8681;\n    }*/\n}\n\n.ant-form-item {\n    margin: 0;\n}\n",".criterion {\n    &__delete {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 18px;\n        text-align: center;\n        color: #C11801;\n        cursor: pointer;\n    }\n\n    &__status-item {\n        padding: 4px 8px 8px 8px;\n        gap: 4px;\n        border-radius: 6px;\n        background: #F1F5F7;\n\n        &__label {\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 24px;\n        }\n\n        &__text {\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 16px;\n        }\n    }\n\n    &__title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: left;\n        color: #092A3A;\n    }\n\n    &__stages-button {\n        width: 440px;\n        height: 58px;\n        padding: 16px;\n        gap: 6px;\n        border-radius: 6px;\n        box-shadow: 0 2px 16px 0 #0000001A;\n        position: fixed;\n        right: 16px;\n        bottom: 16px;\n        cursor: pointer;\n        background: #fff;\n        z-index: 11;\n\n        &__text {\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 21.79px;\n            letter-spacing: 0.3px;\n        }\n\n        &__expand {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 16.34px;\n            text-align: right;\n            color: #417EC6;\n        }\n    }\n\n    &__stages-block {\n        display: flex;\n        flex-flow: column;\n        width: 636px;\n        padding: 16px;\n        gap: 6px;\n        border-radius: 6px;\n        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1019607843);\n        position: fixed;\n        right: 16px;\n        top: 64px;\n        cursor: pointer;\n        background: #fff;\n        overflow-y: auto;\n        max-height: 80vh;\n        z-index: 11;\n    }\n\n    &__message {\n        top: 526px;\n        left: 80px;\n        padding: 16px 24px 24px 24px;\n        gap: 24px;\n        border-radius: 6px ;\n        background: #19BB4F;\n    }\n\n    &__message-title {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 21.79px;\n        text-align: center;\n        color: #fff;\n    }\n\n    &__message-button {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n        padding: 10px 8px 10px 8px;\n        gap: 4px;\n        border-radius: 6px;\n        background: #FFFFFF;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        text-align: center;\n        color: #384146;\n        cursor: pointer;\n    }\n}\n\n.criterion-stages-enter {\n    height: 50px;\n    transform: translateY(850px);\n}\n.criterion-stages-enter-active {\n    height: auto;\n    transform: translateY(0);\n    transition: transform 400ms, height 400ms;\n}\n.criterion-stages-exit {\n    height: 600px;\n    transform: translateY(0);\n}\n.criterion-stages-exit-active {\n    height: 50px;\n    transform: translateY(850px);\n    transition: transform 400ms, height 300ms;\n}\n\n.criterion-stages-button-enter {\n    transform: translateY(-850px);\n}\n.criterion-stages-button-enter-active {\n    transform: translateY(0);\n    transition: transform 400ms;\n}\n.criterion-stages-button-exit {\n    transform: translateY(0);\n}\n.criterion-stages-button-exit-active {\n    transform: translateY(-850px);\n    transition: transform 400ms;\n}\n",".commentary {\n    &__wrapper {\n        height: 100%;\n        display: flex;\n        flex-flow: column;\n        justify-content: flex-end;\n    }\n\n    &__block {\n        display: flex;\n        padding: 32px 20px;\n        border-top: 1px solid #E3E9E5;\n        position: relative;\n    }\n\n    &__list {\n        overflow-y: auto;\n        padding: 12px 0;\n    }\n\n    &__date {\n        border: 1px solid #E3E9E5;\n        border-radius: 6px;\n        position: absolute;\n        top: -13px;\n        left: 40%;\n        padding: 3px 12px;\n        font-size: 12px;\n        font-weight: 600;\n        background: #fff;\n    }\n\n    &__items {\n        width: 100%;\n    }\n\n    &__item {\n        width: 100%;\n        gap: 8px;\n        margin-top: 16px;\n        position: relative;\n\n        &--author {\n            font-size: 12px;\n            font-weight: 700;\n            line-height: 18px;\n            letter-spacing: 0.15px;\n            text-align: left;\n        }\n\n        &--position {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 18px;\n            text-align: left;\n            color: #7E8681;\n        }\n\n        &--time {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 16.34px;\n            letter-spacing: 0.15px;\n            text-align: left;\n            color: #7E8681;\n            white-space: nowrap;\n        }\n\n        &--text {\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 22px;\n            letter-spacing: 0.15px;\n            text-align: left;\n            white-space: break-spaces;\n        }\n\n        &--children {\n            padding: 4px 4px 4px 10px;\n            border-radius: 6px;\n            border: 1px solid #ECECEC;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            cursor: pointer;\n        }\n\n        &--children-items {\n            padding: 0 0 0 16px;\n            width: 100%;\n        }\n\n        &--reply-button {\n            cursor: pointer;\n        }\n\n        &:hover {\n            >.commentary__item--reply-button {\n                display: flex;\n            }\n        }\n    }\n\n    &__field-wrapper {\n        border-top: 1px solid #E6EDF1;\n    }\n\n    &__field {\n        padding: 8px 15px;\n\n        &--button {\n            cursor: pointer;\n        }\n\n        &--author {\n            font-weight: 600;\n        }\n    }\n\n    &__reply {\n        padding: 10px;\n\n        &--close-button {\n            cursor: pointer;\n        }\n    }\n}\n",".planner {\n    &__block-title {\n        color: #092A3A;\n    }\n\n    &__bordered {\n        border: 1px solid #CED9E0;\n        box-sizing: border-box;\n    }\n\n    &__bottom-bordered {\n        border-bottom: 1px solid #CED9E0;\n    }\n\n    &__right-bordered {\n        border-right: 1px solid #CED9E0;\n    }\n\n    &__grey {\n        background: #F8F8F8;\n    }\n\n    &__settings-button {\n        height: 34px;\n        display: flex;\n        align-content: center;\n        border-radius: 6px;\n        padding-top: 4px;\n        padding-right: 10px;\n        padding-bottom: 6px;\n        padding-left: 10px;\n        gap: 8px;\n        background: #F3F6F8;\n        cursor: pointer;\n        white-space: nowrap;\n    }\n\n    &__header-title {\n        color: #1066CB;\n        height: 40px;\n    }\n}\n\n.summary {\n    padding: 8px 12px 12px 12px;\n    gap: 14px;\n    border-radius: 8px;\n    border: 1px solid #E3E9E5;\n    background: #F8F8F8;\n\n    &__items {\n        background: #FFFFFF;\n        border: 1px solid #E3E9E5;\n        padding: 8px;\n        border-radius: 4px;\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 8px;\n\n        &--accepted {\n            border: 1px solid #1066CB;\n        }\n\n        &-item {\n            font-size: 10px;\n            font-weight: 600;\n            line-height: 18px;\n            text-align: left;\n            justify-content: space-between;\n\n            &__label {\n                color: #7E8681;\n            }\n\n            &__valuel {\n                color: #000000;\n            }\n        }\n    }\n\n    &__block-title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0.1px;\n        text-align: left;\n        color: #092A3A;\n\n        &__description {\n            color: #7E8681;\n        }\n\n        &__description-quarter {\n            color: #092A3A;\n        }\n    }\n}\n\n.files {\n    border-top: 1px solid #E3E9E5;\n    padding-top: 8px;\n}\n\n.optimization {\n    border-top: 1px solid #E3E9E5;\n    padding-top: 16px;\n\n    .ant-form-item-label label {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: left;\n        color: #092A3A;\n    }\n\n    &__field-description {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 16px;\n        text-align: left;\n        color: #7E8681;\n    }\n\n    &__description {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 19.07px;\n        letter-spacing: 0.15px;\n        text-align: left;\n        color: #7E8681;\n    }\n\n    &__table {\n        width: 100%;\n        font-size: 12px;\n\n        &-header {\n            padding: 12px 8px;\n            gap: 8px;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 14px;\n            text-align: left;\n            margin-bottom: -1px;\n        }\n\n        &-bordered {\n            border: 1px solid #CED9E0;\n            box-sizing: border-box;\n        }\n\n        &-border-right {\n            border-right: 1px solid #CED9E0;\n        }\n\n        &-border-bottom {\n            border-bottom: 1px solid #CED9E0;\n        }\n\n        &-field {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 4px 8px;\n\n            .ant-form-item-control-input-content {\n                display: flex;\n                justify-content: flex-end;\n            }\n        }\n\n        &-grey {\n            background: #F8F8F8;\n            color: #7E8681;\n        }\n\n        &-field-title {\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 20px;\n            text-align: left;\n            padding: 4px 8px;\n        }\n\n        &-inventory {\n            height: 100%;\n            align-items: flex-start;\n            justify-content: flex-end;\n        }\n\n        input.ant-input-number-input {\n            text-align: right;\n        }\n    }\n\n    &__npvs {\n        color: #1066CB;\n        cursor: pointer;\n    }\n\n    &__npvs-close {\n        cursor: pointer;\n    }\n\n    .channels-block {\n        &__title {\n            font-weight: 600;\n            font-size: 16px;\n            leading-trim: NONE;\n            line-height: 20px;\n            letter-spacing: 0%;\n            vertical-align: middle;\n        }\n    }\n\n    .collapse-item {\n        &__title {\n            font-weight: 600;\n            font-size: 12px;\n            leading-trim: NONE;\n            line-height: 100%;\n            letter-spacing: 0.15px;\n            color: #1066CB;\n        }\n\n        &__date {\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 100%;\n            letter-spacing: 0.15px;\n            color: #85929A;\n        }\n\n        &__input {\n            font-size: 12px;\n        }\n    }\n\n    .ant-collapse-item.ant-collapse-item-active {\n        .collapse-item {\n            &__title {\n                color: #000;\n            }\n        }\n    }\n}\n\n.variant {\n    &__header {\n        padding: 8px;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 14px;\n        text-align: left;\n        border-top-right-radius: 8px;\n        border-top-left-radius: 8px;\n    }\n\n    &__columns {\n        width: 100px;\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n    }\n\n    &__row {\n        width: 100px;\n        display: grid;\n        margin-top: -1px;\n    }\n\n    &__column {\n        min-width: 20%;\n    }\n\n    &__field {\n        padding: 4px 8px;\n\n        &:last-child {\n            border-right: none;\n        }\n    }\n\n    &__field-title {\n        color: #7E8681;\n    }\n\n    &__total {\n        border-bottom-right-radius: 8px;\n        border-bottom-left-radius: 8px;\n        font-weight: 600;\n    }\n}\n\n.ant-layout {\n    .variant-table {\n        &.ant-table-wrapper {\n            .ant-table-thead > tr > th {\n                font-size: 14px;\n                color: #7E8681;\n                font-weight: 600;\n                background: #fff;\n            }\n\n            .ant-table-tbody > tr > td {\n                padding: 2px 8px;\n            }\n\n            .ant-table-tbody > tr:last-child > td {\n                &:first-child {\n                    border-bottom-left-radius: 8px;\n                }\n\n                &:last-child {\n                    border-bottom-right-radius: 8px;\n                }\n            }\n        }\n\n        &.with-total {\n            .ant-table-tbody > tr:last-child > td {\n                font-weight: 600;\n                background: #fafafa;\n            }\n        }\n\n        &__title {\n            color: #000;\n        }\n\n        &__delete-button {\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 18px;\n            text-align: center;\n            color: #C11801;\n        }\n\n        &__accepted.ant-table-wrapper {\n            .ant-table-bordered {\n                border: 1px solid #1066CB;\n                border-radius: 8px;\n            }\n\n            .ant-table-container {\n                border-end-start-radius: 8px;\n                border-end-end-radius: 8px;\n            }\n        }\n    }\n}\n\n.data-factors-collapse {\n    &.ant-collapse {\n        border-radius: unset;\n    }\n    &.ant-collapse>.ant-collapse-item:last-child>.ant-collapse-header {\n        justify-content: space-between;\n        padding: 8px;\n        border-radius: unset;\n    }\n}\n\n.compare {\n    &__cell {\n    }\n\n    &__plan-popover-item_colored {\n        color: #1066CB;\n    }\n\n    &__plan-popover-item {\n        font-weight: 600;\n        cursor: pointer;\n    }\n\n    &__fixed-cell.ant-table-cell {\n        background: #FFFCEE !important;\n    }\n}\n\n.compare-filter {\n    &__title {\n        color: #092A3A;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 18px;\n        text-align: left;\n    }\n\n    &__items-title {\n        border-bottom: 1px solid #E3E9E5;\n        padding: 0 8px 10px 8px;\n        color: #000;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        text-align: left;\n\n    }\n\n    &__items-title-count {\n        color: #7E8681;\n    }\n\n    &__block {\n        padding: 12px 0;\n        gap: 8px;\n        border-radius: 6px;\n        border: 1px solid #E3E9E5;\n    }\n\n    &__item {\n        padding: 2px 12px;\n        color: #000;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        text-align: left;\n    }\n}\n\n.data-total {\n    &__group-title {\n        color: #1A76E2;\n        cursor: pointer;\n\n        &.expanded {\n            color: #7E8681;\n        }\n    }\n}\n\n.total-row {\n    font-weight: 700;\n}\n\n.ant-card .ant-card-body.data-total__card-body {\n    padding: 0;\n}\n\n.highlight {\n    animation: pulse 1s ease-in-out 2;\n}\n\n.compare__items {\n    .ant-table-row[data-row-key=\"total\"],\n    .ant-table-row[data-row-key=\"total_media\"],\n    .ant-table-row[data-row-key=\"total_non_media\"] {\n        font-weight: 600;\n    }\n}\n\n@keyframes pulse {\n    0%, 100% {\n        box-shadow: 0 0 0 0 rgba(24, 143, 207, 0.7);\n    }\n    25%, 75% {\n        box-shadow: 0 0 0 4px rgba(24, 143, 207, 0.4);\n    }\n    50% {\n        box-shadow: 0 0 0 2px rgba(24, 143, 207, 0);\n    }\n}\n",".factor-channels {\n    border-radius: 6px;\n    margin-bottom: -1px;\n\n    &__bordered {\n        border: 1px solid #CED9E0;\n        box-sizing: border-box;\n    }\n\n    &__bottom-bordered {\n        border-bottom: 1px solid #CED9E0;\n    }\n\n    &__top-bordered {\n        border-top: 1px solid #CED9E0;\n    }\n\n    &__right-bordered {\n        border-right: 1px solid #CED9E0;\n    }\n\n    &__grey {\n        background: #F8F8F8;\n    }\n\n    &__field {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 2px 8px;\n    }\n\n    &__name {\n        word-break: break-word;\n    }\n\n    &__upload-title {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 100%;\n        letter-spacing: 0;\n        color: #000000;\n    }\n\n    &__upload-button {\n        border-radius: 6px;\n        padding: 10px 16px;\n        gap: 8px;\n        background-color: #F3F6F8;\n        cursor: pointer;\n        font-size: 14px;\n        color: #384146;\n    }\n\n\n    .ant-radio-wrapper .ant-radio-inner {\n        border-color: unset;\n    }\n\n    .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n        background-color: #000;\n\n        &:after {\n            content: unset;\n        }\n    }\n\n    &__download {\n        border-radius: 6px;\n        padding: 6px 10px;\n        gap: 4px;\n        border: 1px solid #E9EEF0;\n        background: #FAFAFA;\n    }\n}\n\n.highlight-row {\n    background-color: #f0f0f0 !important;\n    transition: background-color 1.5s ease;\n}\n",".report {\n    &__wrapper {\n        padding: 16px 20px;\n        height: 100%;\n\n        .ant-segmented-group {\n            justify-content: space-between;\n\n            .ant-segmented-item {\n                padding: 0 10px;\n            }\n\n            .ant-segmented-item-selected, .ant-segmented-thumb-motion {\n                background: #000;\n                color: #fff;\n            }\n        }\n    }\n\n    &__quarters {\n        .ant-segmented-group {\n            .ant-segmented-item {\n                padding: 0 16px;\n            }\n        }\n    }\n\n    &__empty-text {\n        color: #7E8681;\n    }\n\n    &__link {\n        width: 100%;\n        height: 40px;\n        padding: 7px 15px;\n        border-radius: 6px;\n        background: #1066CB;\n        text-align: center;\n        color: #fff;\n        font-size: 16px;\n\n        &:hover {\n            color: #fff;\n            opacity: 0.9;\n        }\n    }\n}\n\n.report-forecasts {\n    &__title {\n        font-weight: 600;\n        font-size: 14px;\n    }\n\n    &__empty {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 4px;\n        padding-top: 10px;\n        padding-right: 8px;\n        padding-bottom: 10px;\n        padding-left: 8px;\n        background: #FFFCEB;\n        width: 100%;\n        color: #181A1C;\n    }\n\n    &__link {\n        width: 100%;\n        border-radius: 6px;\n        border-width: 1.5px;\n        opacity: 1;\n        gap: 8px;\n        padding-top: 6px;\n        padding-right: 12px;\n        padding-bottom: 6px;\n        padding-left: 10px;\n        border: 1.5px solid #1A76E2;\n        font-weight: 400;\n        font-style: Regular;\n        font-size: 14px;\n        line-height: 20px;\n        color: #1066CB;\n    }\n}\n",".admin-panel {\n    &>div {\n        width: 100%;\n    }\n}\n",".workgroup {\n    &__empty {\n        padding: 10px 8px;\n        border-radius: 4px;\n        background: #EFF5FF;\n        font-size: 11px;\n        font-weight: 400;\n        line-height: 14.98px;\n    }\n\n    &__item {\n        padding: 6px;\n        gap: 8px;\n        border-radius: 4px;\n        border: 1px solid #E9EEF0;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    &__item-user {\n        display: grid;\n        font-size: 12px;\n        grid-template-columns: 1fr 2fr;\n        width: 100%;\n    }\n\n    &__item-name {\n        font-weight: 600;\n    }\n\n    &__item-email {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 16.34px;\n        letter-spacing: 0.15px;\n        text-align: left;\n        color: #85929A;\n    }\n\n    &__item-action {\n        font-size: 12px;\n        cursor: pointer;\n    }\n\n    &__channels {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 16.34px;\n        letter-spacing: 0.15px;\n        text-align: left;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n\n        &-title {\n            font-weight: 600;\n        }\n\n        &-content {\n            width: 100%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
